<template>
	<div class="container">
		<el-row style="height: 100%;position: relative;">
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="left_container full">
						<div class="title flex">位置列表</div>
						<div class="list" style="height: 550px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearrelation">
								<div @click="relationItemClick(item,index,$event)" @dblclick="toRight" class="relation"
									:class="{relation_active:item.active}" v-for="(item,index) in relation" :key="index">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="4" style="height: 100%;position: relative;">
				<div class="middle flex">
					<div>
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-right" circle @click="toRight"></el-button>
					</div>
					<div style="margin-top: 50px;">
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-left" circle @click="toLeft"></el-button>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="right_container full">
						<div class="title flex">授权列表</div>
						<div class="list" style="height: 550px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @dblclick="toLeft" @click="clearDataItem">
								<div @click="dataItemClick(item,index,$event)" class="data"
									:class="{data_active:item.active}" v-for="(item,index) in data" :key="index">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>

</template>
<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 600px;
	}

	.middle {
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.left_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.right_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.title {
		position: relative;
		width: 100%;
		height: 40px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 18px;

		background: rgb(244, 244, 245);
		border-bottom: 1px solid #d7dae2;
	}

	.list {
		position: relative;
		width: 100%;
		height: 410px;
		overflow: auto;
	}

	.relation {
		font-size: 14px;
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
	}

	.relation_active {
		background-color: #409EFF;
		color: white;
	}

	.data {
		font-size: 14px;
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
	}

	.data_active {
		background-color: #409EFF;
		color: white;
	}
</style>
<script>
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				relationloading: false,
				currentrelation: null,
				sourcerelation: {},
				relation: [],
				data: []

			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			this.listrelation()
		},
		mounted() {

		},
		methods: {
			listrelation() {
				// this.$api.relation.list({
				// 	currentPage: -1
				// }).then((res) => {
				// 	this.sourcerelation = res.list
				// 	this.createrelation(res.list)
				// })
				this.sourcerelation = [
					{id:1,name:'发起人部门'},
					{id:2,name:'发起人师傅部门'},
					{id:3,name:'当前操作人部门'},
				]
				this.createrelation(this.sourcerelation)
			},
			createrelation(list) {
				let arr = []
				list.forEach((item) => {
					arr.push({
						id: item.id,
						name: item.name,
						active: false
					})
				})
				this.relation = arr
			},
			relationItemClick(item, index, e) {
				e.stopPropagation()
				this.clearrelation()
				this.relation[index].active = true
				this.currentrelation = item
			},
			clearrelation() {
				this.relation.forEach((item) => {
					item.active = false
				})
			},
			dataItemClick(item, index, e) {
				e.stopPropagation()
				this.clearDataItem()
				this.data[index].active = true
				
			},
			clearDataItem() {
				this.data.forEach((item) => {
					item.active = false
				})
			},
			getActiveDataItem() {
				let obj = null
				this.data.forEach((item, index) => {
					if (item.active) {
						obj = {
							item: item,
							index: index
						}
					}
				})
				return obj
			},
			checkDataItemUnique(checkItem) {
				let obj = null
				this.data.forEach((item) => {
					if (item.id == checkItem.id) {
						obj = true
					}
				})
				return obj
			},
			toRight() {
				if (!this.currentrelation) {
					this.$message.error({
						message: '请选择岗位',
					})
				} else {
					let obj = {
						id: this.currentrelation.id,
						name: this.currentrelation.name,
						active: false,
					}
					if (!this.checkDataItemUnique(obj)) {
						this.data.push(obj)
						this.dataChange()
					} else {
						this.$message.error({
							message: '该选项已存在',
						})
					}

					//console.log(this.currentdepartment,relativep)
				}
			},
			toLeft() {
				let obj = this.getActiveDataItem()
				if (obj) {
					this.data.splice(obj.index, 1)
					this.dataChange()
				}
			},
			submitData() {
				return this.data
			},
			setData(data) {
				data.forEach((item) => {
					item.active = false
				})
				this.data = data
			},
			dataChange(){
				this.$emit('datachange',{data:this.data,type:'relationdepartment'})
			}
		},
		components: {

		}
	}
</script>
